// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

export enum AttachmentType {
  File = 1,
  Item = 2,
  Cloud = 3,
}
